
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';
import { IHubspotPropertiesForDropdown, IHubspotPropertyForDropdown } from './hubspot-model';

@Injectable()
export class HubspotService {

    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${HubspotService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/hubspot';

    public getPropertiesForDropdown(): Observable<SuccessResponse<IHubspotPropertiesForDropdown> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IHubspotPropertiesForDropdown>>(HubspotService.URL + '/properties/dropdown').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
